exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".placeholder[data-v-a3a8f8a4] {\n  background: #f4f4f4;\n  height: 100%;\n  margin: 0;\n  color: #bbb;\n  justify-content: center;\n  align-items: center;\n}", ""]);

// exports
